const LOCALSTORAGE_KEY = "_rspchr";

const localStorageService = {
  getObject() {
    return JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY) || `{}`);
  },
  addToObject(key, value) {
    const current = this.getObject();
    current[key] = value;
    localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(current));
  },
  setItem(key, value, inObject = true) {
    if (inObject) {
      this.addToObject(key, value);
    } else {
      localStorage.setItem(key, value);
    }
  },
  getItem(key, fromObject = true) {
    if (fromObject) {
      const current = this.getObject();
      if (key in current) {
        return current[key];
      }
      return undefined;
    } else {
      return localStorage.getItem(key);
    }
  },
  clearItem(key, fromObject = true) {
    if (fromObject) {
      const current = this.getObject();
      if (current[key]) {
        delete current[key];
        localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(current));
      }
    } else {
      localStorage.removeItem(key);
    }
  },
};

export default localStorageService;
